import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { MatSelectChange } from '@angular/material/select';
import { Frequency } from '@emi/shared/models';
import * as Constants from '@emi/shared/constants';
import { DataExtractionState, getSelectedConfigureData } from '@emi/shared/state/filters';
import { select, Store } from '@ngrx/store';
import { Subscription } from 'rxjs';

@Component({
    selector: 'via-ui-frequency-dropdown',
    templateUrl: './frequency-dropdown.component.html',
    styleUrls: ['./frequency-dropdown.component.scss'],
})
export class FrequencyDropdownComponent implements OnInit, OnDestroy {
    
    @Input()
    public selectedFrequency: Frequency;

    @Input()
    public panelClass = 'e-mat-select-panel';

    @Output()
    public frequencyChange = new EventEmitter<Frequency>();
    
    private configureDataSubscription: Subscription;
    public frequencyOptions: Frequency[] = Constants.frequencyOptions;

    constructor(private store: Store<DataExtractionState>) {}
      public ngOnInit(): void {
        this.configureDataSubscription = this.store
        .pipe(select(getSelectedConfigureData))
        .subscribe((configureData) => {

            if (!configureData.frequency) {
            const defaultFrequency = Constants.Application.DEFAULT_FREQUENCY
            this.selectedFrequency = defaultFrequency!;
            return;
            }

            const frequency = this.frequencyOptions.find(frequency => frequency == configureData.frequency)
            this.selectedFrequency = frequency!;
        });
    }
   

    public onFrequencyChange(event: MatSelectChange): void {
        this.frequencyChange.emit(event.value);
    }

    public ngOnDestroy(): void {
        this.configureDataSubscription.unsubscribe();
    }
}
